var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"titlePopup"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(!_vm.hideClose)?_c('button',{on:{"click":_vm.onClosePopup}},[_vm._v("x")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }